import type { Sport } from '@painpal/contracts';
import { Activity, Bike, Dumbbell, Footprints, Mountain, Waves, type LucideIcon } from 'lucide-react';
import { plural } from './plural';

export interface SportMeta { label: string; Icon: LucideIcon; noun: readonly [string, string] }

export const SPORT_META: Record<Sport, SportMeta> = {
  ride: { label: 'RIDE', Icon: Bike, noun: ['RIDE', 'RIDES'] },
  run: { label: 'RUN', Icon: Footprints, noun: ['RUN', 'RUNS'] },
  swim: { label: 'SWIM', Icon: Waves, noun: ['SWIM', 'SWIMS'] },
  walk: { label: 'WALK / HIKE', Icon: Mountain, noun: ['WALK', 'WALKS'] },
  strength: { label: 'STRENGTH', Icon: Dumbbell, noun: ['SESSION', 'SESSIONS'] },
  other: { label: 'OTHER', Icon: Activity, noun: ['ACTIVITY', 'ACTIVITIES'] },
};

const ALL_NOUN = ['ACTIVITY', 'ACTIVITIES'] as const;

export function sportNoun(sport: Sport | 'all', count: number): string {
  const [one, many] = sport === 'all' ? ALL_NOUN : SPORT_META[sport].noun;
  return plural(count, one, many);
}

export const sportCount = (sport: Sport | 'all', count: number): string => `${count} ${sportNoun(sport, count)}`;
